import moment from 'moment';

import {SearchResult, SearchResultType} from 'common/report/util/search/types';
import {BookmarkType, SavedBookmark} from 'common/report/queries/app-api/bookmark-client';
import {Dashboard} from 'common/report/queries/app-api/dashboard-types';
import {SerializedCohort} from 'common/widgets/cohorts-query-builder/models/types/serialized-cohort-types';

export const testSearch: SearchResult[] = [
  {
    type: SearchResultType.Report,
    id: 8683307,
    name: `share API calls`,
    description: ``,
    last_edited: `2020-04-29T22:07:44`,
    user: `Steve Cobb`,
    scores: {
      time: 27.019269332359848,
      filter: 75,
      equality: 0,
      text: 75,
      popularity: 0,
      final: 54.50321155536715,
    },
    user_id: 1030710,
    report: `insights`,
    link: `/report/3/insights/#report/8683307`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: false,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: false,
    email: `steve.cobb@mixpanel.com`,
  },
  {
    type: SearchResultType.Report,
    id: 8573811,
    name: `Shares by Type (user, team, project)`,
    description: ``,
    last_edited: `2020-05-08T16:37:49`,
    user: `Ryan Hirsch`,
    scores: {
      time: 28.220761277674722,
      filter: 60,
      equality: 0,
      text: 61.75,
      popularity: 0,
      final: 45.28679354626697,
    },
    user_id: 1732309,
    report: `insights`,
    link: `/report/3/insights/#report/8573811`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: true,
    email: `ryan.hirsch@gmail.com`,
  },
  {
    type: SearchResultType.Dashboard,
    id: 623960,
    name: `Sharing and Permissions`,
    description: `This dashboards is for tracking sharing of Dashboards, Reports, Cohorts, Custom Events and Custom Properties`,
    last_edited: `2020-09-02T16:23:37`,
    user: `Ryan Hirsch`,
    scores: {
      time: 44.24680770064688,
      filter: 14.5,
      equality: 0,
      text: 14.5,
      popularity: 0,
      final: 17.041134616765493,
    },
    user_id: 1732309,
    report: null,
    link: `/report/3/dashboards#id=623960`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: true,
    email: `ryan.hirsch@gmail.com`,
  },
  {
    type: SearchResultType.Report,
    id: 8278264,
    name: `did shares send emails`,
    description: ``,
    last_edited: `2020-04-29T20:26:13`,
    user: `Steve Cobb`,
    scores: {
      time: 27.00961211450882,
      filter: 18.5,
      equality: 0,
      text: 18.5,
      popularity: 0,
      final: 16.834935352409417,
    },
    user_id: 1030710,
    report: `insights`,
    link: `/report/3/insights/#report/8278264`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: false,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: false,
    email: `steve.cobb@mixpanel.com`,
  },
  {
    type: SearchResultType.Report,
    id: 8572372,
    name: `Sharing Grant CUD`,
    description: ``,
    last_edited: `2020-05-31T22:44:41`,
    user: `Ryan Hirsch`,
    scores: {
      time: 31.40634600581082,
      filter: 13.5,
      equality: 0,
      text: 15.75,
      popularity: 0,
      final: 14.984391000960015,
    },
    user_id: 1732309,
    report: `insights`,
    link: `/report/3/insights/#report/8572372`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: true,
    email: `ryan.hirsch@gmail.com`,
  },
  {
    type: SearchResultType.Report,
    id: 8572336,
    name: `Sharing Modal Opened`,
    description: ``,
    last_edited: `2020-04-17T19:26:30`,
    user: `Ryan Hirsch`,
    scores: {
      time: 25.360095688589237,
      filter: 16,
      equality: 0,
      text: 16,
      popularity: 0,
      final: 14.893349281423083,
    },
    user_id: 1732309,
    report: `insights`,
    link: `/report/3/insights/#report/8572336`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: true,
    email: `ryan.hirsch@gmail.com`,
  },
  {
    type: SearchResultType.Report,
    id: 8567287,
    name: `Sharing Modal By Entity Type`,
    description: ``,
    last_edited: `2020-04-17T16:51:04`,
    user: `Ryan Hirsch`,
    scores: {
      time: 25.34530941245085,
      filter: 12,
      equality: 0,
      text: 13.5,
      popularity: 0,
      final: 12.72421823539949,
    },
    user_id: 1732309,
    report: `insights`,
    link: `/report/3/insights/#report/8567287`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: true,
    email: `ryan.hirsch@gmail.com`,
  },
  {
    type: SearchResultType.Report,
    id: 8903984,
    name: `Sharing Beta Users + Usage of Custom*`,
    description: ``,
    last_edited: `2020-05-27T00:33:44`,
    user: `Jess Chaidez`,
    scores: {
      time: 30.731788357022133,
      filter: 9.5,
      equality: 0,
      text: 11.25,
      popularity: 0,
      final: 12.03863139282751,
    },
    user_id: 1824949,
    report: `insights`,
    link: `/report/3/insights/#report/8903984`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: false,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: false,
    email: `jess.chaidez@mixpanel.com`,
  },
  {
    type: SearchResultType.Report,
    id: 8144215,
    name: `UXW: Sign-up to Sharing`,
    description: ``,
    last_edited: `2020-04-10T22:41:55`,
    user: `Vlado Hruda`,
    scores: {
      time: 24.419781444155888,
      filter: 10.5,
      equality: 0,
      text: 12.75,
      popularity: 0,
      final: 11.819963574017526,
    },
    user_id: 1437649,
    report: `funnels`,
    link: `/report/3/funnels/#view/8144215`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: true,
    email: `vlado@comcast.net`,
  },
  {
    type: SearchResultType.Report,
    id: 7256905,
    name: `QBQ | Answer Volume + Share of Answers by Users`,
    description: `This report shows how many answers are posted in Community each week, and what percentage of those answers is posted by real users as opposed to the Community team.`,
    last_edited: `2020-05-18T23:01:55`,
    user: `Marco Sanchez Junco`,
    scores: {
      time: 29.627163483607625,
      filter: 9.5,
      equality: 0,
      text: 10,
      popularity: 0,
      final: 11.437860580591229,
    },
    user_id: 310851,
    report: `insights`,
    link: `/report/3/insights/#report/7256905`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: true,
    email: `marco@hotmail.com`,
  },
  {
    type: SearchResultType.Report,
    id: 8567556,
    name: `Sharing Modal Links vs Short Link Widget (P3)`,
    description: ``,
    last_edited: `2020-04-17T19:25:36`,
    user: `Ryan Hirsch`,
    scores: {
      time: 25.360010071496067,
      filter: 8,
      equality: 0,
      text: 9.25,
      popularity: 0,
      final: 9.976668345239569,
    },
    user_id: 1732309,
    report: `insights`,
    link: `/report/3/insights/#report/8567556`,
    unique_count: 0,
    total_count: 0,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    can_share: true,
    email: `ryan.hirsch@gmail.com`,
  },
];

export const entityData: SearchResult[] = [
  {
    can_share: true,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    description: ``,
    id: 1,
    is_superadmin: true,
    last_edited: `2020-06-10T08:41:50`,
    link: `/report/3/insights/#report/1`,
    name: `Test Bookmark 1`,
    report: `insights`,
    scores: {final: 50, popularity: 100},
    type: SearchResultType.Report,
    unique_count: 100,
    user: `User 1`,
    user_id: 1,
    email: `user1@hotmail.com`,
  },
  {
    can_share: true,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    description: `Description`,
    id: 2,
    is_superadmin: true,
    last_edited: `2020-06-08T08:41:50`,
    link: `/report/3/insights/#report/2`,
    name: `Test Bookmark 2`,
    report: `insights`,
    scores: {final: 50, popularity: 50},
    type: SearchResultType.Report,
    unique_count: 200,
    user: `User 1`,
    user_id: 1,
    email: `user1@hotmail.com`,
  },
  {
    can_share: true,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    description: ``,
    id: 3,
    is_superadmin: true,
    last_edited: `2020-06-07T08:41:50`,
    link: `/report/3/insights/#report/3`,
    name: `Test Bookmark 3`,
    report: `insights`,
    scores: {final: 50, popularity: 51},
    type: SearchResultType.Report,
    unique_count: 300,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
  },
  {
    can_share: false,
    can_update_basic: false,
    can_view: true,
    allow_staff_override: false,
    is_superadmin: false,
    description: ``,
    id: 4,
    last_edited: `2020-06-06T08:41:50`,
    link: `/report/3/funnels/#report/4`,
    name: `Test Bookmark 4`,
    report: `funnels`,
    scores: {final: 50, popularity: 50},
    type: SearchResultType.Report,
    unique_count: 400,
    user: `User 1`,
    user_id: 1,
    email: `user1@hotmail.com`,
  },
  {
    can_share: false,
    can_update_basic: false,
    can_view: false,
    allow_staff_override: false,
    is_superadmin: true,
    description: ``,
    id: 5,
    last_edited: `2020-06-03T08:41:50`,
    link: `/report/3/retention/#report/5`,
    name: `Test Bookmark 5`,
    report: `retention`,
    scores: {final: 50, popularity: 50},
    type: SearchResultType.Report,
    unique_count: 500,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
  },
];

export const bookmarksRaw: Array<SavedBookmark<unknown>> = entityData.map((entity) => ({
  created: ``,
  icon: ``,
  id: entity.id,
  isDefault: true,
  modified: moment(entity.last_edited),
  name: entity.name,
  originalType: ``,
  params: {},
  projectId: 42,
  title: entity.name,
  type: entity.report as BookmarkType,
  userId: entity.user_id,
  user: entity.user,
  userName: entity.user,
}));

export const dashboardEntities: SearchResult[] = [
  {
    can_share: true,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    description: `Questions relating to use of data classification features.`,
    id: 1,
    is_superadmin: true,
    last_edited: `2020-06-03T22:13:02`,
    link: `/report/3/dashboards#id=1`,
    name: `Test Dashboard 1`,
    report: null,
    scores: {popularity: 100, final: 100},
    type: SearchResultType.Dashboard,
    unique_count: 3,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
  },
  {
    can_share: true,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    description: `Test Dashboard 2 description hey!`,
    id: 89812,
    is_superadmin: true,
    last_edited: `2020-06-03T22:13:02`,
    link: `/report/3/dashboards#id=89812`,
    name: `Test Dashboard 2`,
    report: null,
    scores: {popularity: 100, final: 100},
    type: SearchResultType.Dashboard,
    unique_count: 3,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
  },
  {
    can_share: true,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    description: `Test Dashboard 3 description hey!`,
    id: 89812123,
    is_superadmin: true,
    last_edited: `2020-06-03T22:13:02`,
    link: `/report/3/dashboards#id=89812123`,
    name: `Test Dashboard 3`,
    report: null,
    scores: {popularity: 100, final: 100},
    type: SearchResultType.Dashboard,
    unique_count: 3,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
  },
];

export const dashboardsRaw: Dashboard[] = dashboardEntities.map((entity) => ({
  id: entity.id,
  title: entity.name,
  description: entity.description,
  is_private: false,
  cards: [],
  time_filter: {},
  filters: [],
  card_order: [],
  creator: entity.user,
  creator_id: entity.user_id,
  creator_name: entity.user,
  creator_email: entity.email,
  is_restricted: true,
  modified: moment(entity.last_edited).format(`YYYY-MM-DD`),
  can_update_basic: entity.can_update_basic,
  can_view: true,
  allow_staff_override: false,
  is_superadmin: entity.is_superadmin,
  can_share: entity.can_share,
}));

export const exploreEntities: SearchResult[] = [
  {
    can_share: true,
    can_update_basic: true,
    can_view: true,
    allow_staff_override: false,
    description: `Funnel Report: Untitled. Users who did [Verified] Query then did NOT do [Verified] Learning Action [server]. Time Range: In the last 30 days`,
    id: 1,
    is_superadmin: true,
    last_edited: `2020-06-03T22:13:02`,
    link: `/report/3/explore#list/cohort_id=1`,
    name: `Test Cohort 1`,
    report: null,
    scores: {popularity: 100, final: 100},
    type: SearchResultType.Cohort,
    unique_count: 3,
    user: `User 2`,
    user_id: 2,
    email: `user2@hotmail.com`,
  },
];

export const exploreRaw: SerializedCohort[] = exploreEntities.map((entity) => ({
  created_by: {
    name: entity.user,
    email: entity.email,
    id: entity.user_id,
  },
  description: entity.description,
  id: entity.id,
  last_edited: entity.last_edited,
  last_queried: entity.last_edited,
  name: entity.name,

  // permissions
  can_view: entity.can_view,
  can_update_basic: entity.can_update_basic,
  can_share: entity.can_share,
  is_superadmin: entity.is_superadmin,
  allow_staff_override: entity.allow_staff_override,
}));
